import { Link } from "react-router-dom";
import "../assets/css/main.css";
import Layout from "../components/Layout";

export default function HostingPage() {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="hero-overlay">
        <div className="hero-visuals">
          <img src="/assets/images/webHostingMain.png" alt="Web Main" />
        </div>
        <div className="hero-content">
          <h1>Website Hosting</h1>
          <p>
            Empower your online presence with lightning-fast, eco-friendly
            hosting solutions tailored for your business.
          </p>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="split-section">
        <div className="split-text">
          <h2>Why Choose TearabyteSS?</h2>
          <ul>
            <li>
              <strong>99.9% Uptime:</strong> Keep your site online around the clock.
            </li>
            <li>
              <strong>Fast Loading:</strong> Optimised performance for users and SEO.
            </li>
            <li>
              <strong>Enhanced Security:</strong> Daily backups and active threat monitoring.
            </li>
            <li>
              <strong>Eco-Friendly:</strong> Solar-powered infrastructure.
            </li>
          </ul>
        </div>
        <div className="split-image">
          <img
            src="/assets/images/chooseTearabytess.png"
            alt="Servers"
          />
        </div>
      </section>

      {/* Plan */}
      <section className="split-section reverse">
        <div className="split-text">
          <h2>Starter Plan - £2.99/month</h2>
          <p>
            Perfect for small businesses, personal blogs, and startups.
          </p>
          <ul>
            <li>1GB Storage</li>
            <li>10GB Monthly Bandwidth</li>
            <li>Daily Backups</li>
            <li>24/7 Support</li>
          </ul>
          <Link to="/contact" className="cta-link">
            Request a Custom Quote
          </Link>
        </div>
        <div className="split-image">
          <img
            src="/assets/images/starterPlan.png"
            alt="Hosting Plan"
          />
        </div>
      </section>

      {/* Call to Action */}
      <section className="contact-cta">
        <h2>Ready to elevate your hosting?</h2>
        <Link to="/contact" className="contactLink">
          Contact Us Today
        </Link>
      </section>
    </Layout>
  );
}
